import {
  useEffect,
  useState,
  FC,
  SetStateAction,
  Dispatch,
  useRef,
} from "react";

interface IPropsNotification {
  notification: any;
  setShow: Dispatch<SetStateAction<boolean>>;
  show: boolean;
}

const Notification: FC<IPropsNotification> = ({
  notification,
  show,
  setShow,
}) => {
  const timeoutRef = useRef<any>();

  useEffect(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    if (show) {
      timeoutRef.current = setTimeout(() => {
        setShow(false);
      }, 5000);
    }
  }, [show]);

  const handleClickNotif = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setShow(false);
  };

  if (show) {
    return (
      <div onClick={handleClickNotif} className="notificationContainer">
        <div className="notifTitle">{notification.title}</div>
        <div className="notifSubject">{notification.body}</div>
      </div>
    );
  } else {
    return null;
  }
};

export default Notification;
